import { PixelCrop } from 'react-image-crop'

const TO_RADIANS = Math.PI / 180

export async function canvasPreview(
    image: HTMLImageElement,
    canvas: HTMLCanvasElement,
    crop: PixelCrop,
    scale = 1,
    rotate = 0,
    flip: { horizontal: boolean; vertical: boolean } = { horizontal: false, vertical: false },
    circularCrop = false,
) {
    const ctx = canvas.getContext('2d')

    if (!ctx) {
        throw new Error('No 2d context')
    }

    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = window.devicePixelRatio
    // const pixelRatio = 1

    canvas.width = Math.floor(crop.width * scaleX * pixelRatio)
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio)
    canvas.style.margin = '0'
    canvas.style.padding = '0'

    ctx.scale(pixelRatio, pixelRatio)
    ctx.imageSmoothingQuality = 'high'

    const cropX = crop.x * scaleX
    const cropY = crop.y * scaleY

    const rotateRads = rotate * TO_RADIANS
    const centerX = image.naturalWidth / 2
    const centerY = image.naturalHeight / 2

    ctx.save()

    // 5) Move the crop origin to the canvas origin (0,0)
    ctx.translate(-cropX, -cropY)
    // 4) Move the origin to the center of the original position
    ctx.translate(centerX, centerY)
    // 3) Rotate around the origin
    ctx.rotate(rotateRads)
    // 2) Scale the image
    ctx.scale(flip.horizontal ? -scale : scale, flip.vertical ? -scale : scale)
    // 1) Move the center of the image to the origin (0,0)
    ctx.translate(-centerX, -centerY)

    if (circularCrop) {
        if (crop.width === crop.height) {
            // Draw the circular crop
            const radius = Math.min(crop.width * scaleX, crop.height * scaleY) / 2
            const x = cropX + radius
            const y = cropY + radius
            ctx.beginPath()
            ctx.arc(x, y, radius, 0, 2 * Math.PI)
            ctx.closePath()
            ctx.clip()
        } else {
            // Draw ellipse crop
            const radiusX = (crop.width * scaleX) / 2
            const radiusY = (crop.height * scaleY) / 2
            const x = cropX + radiusX
            const y = cropY + radiusY
            ctx.beginPath()
            ctx.ellipse(x, y, radiusX, radiusY, 0, 0, 2 * Math.PI)
            ctx.closePath()
            ctx.clip()
        }
    }

    ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight)

    ctx.restore()
}
